import React, { useState } from "react";

const IncomeStatementViewer = () => {
  const [driveLink, setDriveLink] = useState("");
  const [statement, setStatement] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const generateStatement = async () => {
    if (!driveLink) return alert("Enter Google Drive link");

    setLoading(true);
    setError("");
    setStatement(null);

    try {
      const fd = new FormData();
      fd.append("driveLink", driveLink);

      const res = await fetch(
        "https://www.d-rosa.ai/generate-income-statement",
        {
          method: "POST",
          body: fd
        }
      );

      const data = await res.json();

      if (!data.success) throw new Error(data.error);

      setStatement(data.incomeStatement);

    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  const getGross = () => {
    const trading = statement?.TradingAccount;
    if (!trading) return {};

    if (trading["Gross Profit"])
      return { label: "Gross Profit", value: trading["Gross Profit"], profit: true };

    if (trading["Gross Loss"])
      return { label: "Gross Loss", value: trading["Gross Loss"], profit: false };

    return {};
  };

  const getNet = () => {
    const pl = statement?.ProfitAndLossAccount;
    if (!pl) return {};

    if (pl["Net Profit"])
      return { label: "Net Profit", value: pl["Net Profit"], profit: true };

    if (pl["Net Loss"])
      return { label: "Net Loss", value: pl["Net Loss"], profit: false };

    return {};
  };

  const gross = getGross();
  const net = getNet();

  const blueColor = "#1E3A8A"; // Professional Blue

  return (
    <div style={{ maxWidth: 900, margin: "auto", padding: 20 }}>
      <h2 style={{ color: blueColor }}>Income Statement</h2>

      <input
        style={{ width: "100%", padding: 10 }}
        placeholder="Paste Google Drive Folder Link"
        value={driveLink}
        onChange={(e) => setDriveLink(e.target.value)}
      />

      <button
        onClick={generateStatement}
        style={{
          marginTop: 15,
          padding: 10,
          backgroundColor: blueColor,
          color: "white",
          border: "none",
          cursor: "pointer"
        }}
      >
        Generate Statement
      </button>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {statement && (
        <>
          <table border="1" width="100%" cellPadding="8">
            <tbody>
              {Object.entries(statement.TradingAccount).map(([key, value]) => (
                <tr key={key}>
                  <td>{key}</td>
                  <td
                    style={{
                      fontWeight: key.includes("Gross") ? "bold" : "normal",
                      color:
                        key === "Gross Profit"
                          ? "green"
                          : key === "Gross Loss"
                          ? "red"
                          : "black"
                    }}
                  >
                    {value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3 style={{ marginTop: 30 }}>Profit & Loss Account</h3>
          <table border="1" width="100%" cellPadding="8">
            <tbody>
              {Object.entries(statement.ProfitAndLossAccount).map(
                ([key, value]) => (
                  <tr key={key}>
                    <td>{key}</td>
                    <td
                      style={{
                        fontWeight: key.includes("Net") ? "bold" : "normal",
                        color:
                          key === "Net Profit"
                            ? "green"
                            : key === "Net Loss"
                            ? "red"
                            : "black"
                      }}
                    >
                      {value}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default IncomeStatementViewer;